export const generateRandomNumber = (digits: number) =>
  Math.ceil(Math.random() * Math.pow(10, digits));
